///<amd-module name="typeahead/core/message/OriginPopulationMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class OriginPopulationMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.origin_population";
    }

    public getTopic(): string {
        return OriginPopulationMessage.getTopic();
    }

}
